/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/AuthorDetails/theme';

export const AuthorDetailsTheme = theme;
